







import { Component, Vue } from 'vue-property-decorator'
import BeaconList from '@/components/beacon/BeaconList.vue'

@Component({
  name: 'Beacon',
  components: {
    BeaconList,
  },
  computed: {},
})
export default class Beacon extends Vue {
  get labelBreadcrumb(): string {
    return this.$t('breadcrumb.beacon_info_manage') as string
  }
}
